import { Grid } from '@mui/material';
import FieldText from '../../../../components/general/fields/fieldText';
import FieldSelect from '../../../../components/general/fields/fieldSelect';
import dayjs from 'dayjs';
import { usePqrFilters } from './hook';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { PqrFiltersProps } from './props';
import { Checkbox } from '../../../../components/general/fields/checkbox';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import DatePickerField from '../../../../components/general/fields/datePickerField';
import { PqrReception } from '../../../../../shared/types/modules/pqr';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import MultipleAutocompleteField from '../../../../components/general/fields/multipleAutocompleteField';

export const PqrFilters = ({
    onFilter,
    loading,
    selectionModel,
}: PqrFiltersProps) => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const {
        formik,
        receptionChannels,
        halfs,
        types,
        processingAreas,
        incharges,
        status,
        reconsiderations,
        onHandleClick,
    } = usePqrFilters(onFilter, selectionModel);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="ID caso"
                    name="caseId"
                    size="small"
                    touched={formik.touched.caseId}
                    errors={formik.errors.caseId}
                    value={formik.values.caseId}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="PQR ID"
                    name="pqrId"
                    size="small"
                    touched={formik.touched.pqrId}
                    errors={formik.errors.pqrId}
                    value={formik.values.pqrId}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="SFC ID"
                    name="sfcId"
                    size="small"
                    touched={formik.touched.sfcId}
                    errors={formik.errors.sfcId}
                    value={formik.values.sfcId}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Identificación"
                    name="document"
                    size="small"
                    touched={formik.touched.document}
                    errors={formik.errors.document}
                    value={formik.values.document}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} md={8}>
                <FieldText
                    label="Nombre / Razón social"
                    name="name"
                    size="small"
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MultipleAutocompleteField
                    data={receptionChannels}
                    label="Canal de recepción"
                    name="receptionChannel"
                    size="small"
                    touched={formik.touched.receptionChannel}
                    errors={formik.errors.receptionChannel}
                    value={formik.values.receptionChannel}
                    onChangeValue={(selectedOptions: any[]) => {
                        const selectedNames = selectedOptions.map(
                            (opt) => opt.code
                        );
                        formik.setFieldValue('receptionChannel', selectedNames);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MultipleAutocompleteField
                    data={halfs}
                    label="Medio"
                    name="half"
                    size="small"
                    touched={formik.touched.half}
                    errors={formik.errors.half}
                    value={formik.values.half}
                    onChangeValue={(selectedOptions: any[]) => {
                        const selectedNames = selectedOptions.map(
                            (opt) => opt.name
                        );
                        formik.setFieldValue('half', selectedNames);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MultipleAutocompleteField
                    data={types}
                    label="Tipo PQR"
                    name="type"
                    size="small"
                    touched={formik.touched.type}
                    errors={formik.errors.type}
                    value={formik.values.type}
                    onChangeValue={(selectedOptions: any[]) => {
                        const selectedNames = selectedOptions.map(
                            (opt) => opt.code
                        );
                        formik.setFieldValue('type', selectedNames);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MultipleAutocompleteField
                    data={processingAreas}
                    label="Sucursal de expedición"
                    name="branch"
                    size="small"
                    touched={formik.touched.branch}
                    errors={formik.errors.branch}
                    value={formik.values.branch}
                    onChangeValue={(selectedOptions: any[]) => {
                        const selectedNames = selectedOptions.map(
                            (opt) => opt.code
                        );
                        formik.setFieldValue('branch', selectedNames);
                    }}
                />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
                <MultipleAutocompleteField
                    data={incharges}
                    label="Encargado"
                    name="incharge"
                    size="small"
                    touched={formik.touched.incharge}
                    errors={formik.errors.incharge}
                    value={formik.values.incharge}
                    onChangeValue={(selectedOptions: any[]) => {
                        const selectedNames = selectedOptions.map(
                            (opt) => opt.code
                        );
                        formik.setFieldValue('incharge', selectedNames);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MultipleAutocompleteField
                    data={reconsiderations}
                    label="Reconsideración"
                    name="reconsideration"
                    size="small"
                    touched={formik.touched.reconsideration}
                    errors={formik.errors.reconsideration}
                    value={formik.values.reconsideration}
                    onChangeValue={(selectedOptions: any[]) => {
                        const selectedNames = selectedOptions.map(
                            (opt) => opt.code
                        );
                        formik.setFieldValue('reconsideration', selectedNames);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Checkbox
                    beforeLabel="Encuesta"
                    label="¿Se diligenció encuesta?"
                    checked={Boolean(formik.values.survey)}
                    onChange={() => {
                        formik.setFieldValue('survey', !formik.values.survey);
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Radicado de correspondencia"
                    name="correspondenceFiling"
                    size="small"
                    touched={formik.touched.correspondenceFiling}
                    errors={formik.errors.correspondenceFiling}
                    value={formik.values.correspondenceFiling as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <MultipleAutocompleteField
                    data={status}
                    label="Estado"
                    name="status"
                    size="small"
                    touched={formik.touched.status}
                    errors={formik.errors.status}
                    value={formik.values.status}
                    onChangeValue={(selectedOptions: any[]) => {
                        const selectedNames = selectedOptions.map(
                            (opt) => opt.code
                        );
                        formik.setFieldValue('status', selectedNames);
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldSelect
                    data={[
                        PqrReception.CRM,
                        PqrReception.PQR_WEB,
                        PqrReception.SFC,
                    ].map((item) => ({ id: item, name: item }))}
                    label="Origen"
                    name="reception"
                    size="small"
                    touched={formik.touched.reception}
                    errors={formik.errors.reception}
                    value={formik.values.reception as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación inicial"
                    name="startCreatedAt"
                    size="small"
                    maxDate={dayjs().endOf('day')}
                    touched={formik.touched.startCreatedAt}
                    errors={formik.errors.startCreatedAt?.toString()}
                    value={formik.values.startCreatedAt}
                    onChange={(value) =>
                        formik.setFieldValue('startCreatedAt', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de creación final"
                    name="endCreatedAt"
                    size="small"
                    minDate={dayjs(formik.values.startCreatedAt)}
                    maxDate={dayjs().endOf('day')}
                    disabled={!formik.values.startCreatedAt}
                    touched={formik.touched.endCreatedAt}
                    errors={formik.errors.endCreatedAt?.toString()}
                    value={formik.values.endCreatedAt}
                    onChange={(value) =>
                        formik.setFieldValue('endCreatedAt', value, true)
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
            {!isOnlyViewProfile(type) && (
                <Grid item xs={12}>
                    <LoadingButtonGeneral
                        disabled={loading}
                        title="Alerta individual"
                        variant="outlined"
                        onClick={onHandleClick}
                        startIcon={<ContactMailIcon />}
                    />
                </Grid>
            )}
        </Grid>
    );
};
